export default __webpack_public_path__ + "static/media/LINE_APP.024af070.png";